import {cookiesUtils} from "../../helpers/cookies.utils";
import {environment} from "../../../environments/environment";

export abstract class BaseComponent {
  protected cookies!: string;
  protected idRegion!: number;

  protected constructor() {
    this.initializeCookiesAndRegion();
  }

  private initializeCookiesAndRegion(): void {
    const { idRegion, cookies } = cookiesUtils.getCookiesAndRegion() || {};
    this.cookies = cookies || '';
    if (idRegion !== undefined) {
      this.idRegion = idRegion;
    }

    if (cookies == undefined || idRegion == undefined) {
      window.location.href = environment.homeDir;
    }
  }
}
